import { createContext } from "react";
import type { Empresa, EmpresaErro } from "./useEmpresaAtiva";

/**
 * O CONTEXTO da empresa ativa — só o `createContext`, num arquivo sem React Query,
 * sem Supabase e sem `useAuth`.
 *
 * POR QUE ele saiu de `useEmpresaAtiva.tsx` (12/10/2026, apartar a Regula da M5):
 * 53 testes fazem `vi.mock("../src/client/hooks/useEmpresaAtiva")` devolvendo só
 * `useEmpresaAtiva`. Qualquer OUTRO export daquele arquivo (o `useEmpresaAtivaOpcional`,
 * o próprio contexto) vira "export não definido no mock" e derruba o teste. O gate por
 * módulo (`useTemModulo`) precisa ler a empresa ativa de dentro de componentes que
 * renderizam SEM provider nos testes (ListaContasCp, modais) — então ele lê DAQUI, e
 * um mock do hook não o alcança: sem provider, `modulos` é null e tudo fica ligado,
 * exatamente o que esses 53 testes sempre viram.
 */
export interface EmpresaCtx {
  empresas: Empresa[];
  ativa: Empresa | null;
  trocar: (empresaId: string) => void;
  loading: boolean;
  erro: EmpresaErro | null;
  /** Nome da empresa que OUTRA aba passou a usar. null = ninguém mexeu. */
  trocaEmOutraAba: string | null;
}

export const EmpresaAtivaCtx = createContext<EmpresaCtx | undefined>(undefined);
